<div class="contenuto">

  <div class="success" *ngIf="successo">
    <span class="material-symbols-outlined icona ok">check_circle_outline</span>
    <div class="title" data-tid="elements_examples.success.title">{{ 'step3.successo.titoloOK' | translate}}</div>
    <div class="message" [innerHTML]="'step3.successo.testoHTMLok' | translate"></div>
  </div>


  <div class="error" *ngIf="!successo">
    <span class="material-symbols-outlined icona errore">highlight_off</span>
    <div class="title" data-tid="elements_examples.success.title">{{ 'step3.successo.titoloKO' | translate}}</div>
    <div class="message" [innerHTML]="'step3.successo.testoHTMLko' | translate"></div>
    <p><i>{{errore}}</i></p>
    <button class="btn red" (click)="backToSetp2()">
      {{'base.torna_finale' | translate}}
    </button>
  </div>

</div>